<template>
  <div>
    <div class="flexc-cen-x fixed">
      <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>{{WZXMName}}</el-breadcrumb-item>
          </el-breadcrumb>
          <el-select v-if="DianList.length>1" style="margin-left:20px;width:140px" size="mini" v-model="SelectStoresID" @change="changedian()" placeholder="门店">
            <el-option
                    v-for="item in DianList"
                    :key="item.ID"
                    :label="item.StoresName"
                    :value="item.ID">
                  </el-option>
      </el-select>
    </div>
    <el-container style="padding-top:15px">
<!-- 8c4ce2 -->
        <el-aside width="210px" >
    <!-- 搜索筛选 -->
            <el-form :inline="true" :model="formInline" class="user-search">
                <el-button size="medium" style="width:95%;" v-if="q1 == true"   type="primary" icon="el-icon-plus" @click="handlePassword()">添加{{WZXMName}}类别</el-button>
            </el-form>
            <div class="title flexc-cen-x cursor"  @click="toAll()"> 
                <div style="margin-left:10px">所有类别<i class="el-icon-refresh-left"  style="margin-left:110px;font-size:18px"></i> </div>
            </div>
            <div style="height:63vh;overflow:auto;">
              <div class="css" v-for="(item,index) in typeList" style="width:95%;margin-top:20px;margin-bottom:2px" >
                <div v-if="item.ID == active" class="flex-xy  cursor shadow" id="shadw" style="width:96%;margin-left:2%;border-radius:5px;border:1px solid #409EFF">
                    <div style="width:95%;padding-top:10px;padding-bottom:10px">
                        <div class="flex-spc-x">
                            <div class="flexc-cen-x">
                                <i class="el-icon-s-unfold"></i>
                                <div style="font-size:15px;margin-left:7px">{{item.ProjectTypeName}}</div>
                            </div>
                        </div>
                        <div class="flex-r-x" style="margin-top:10px">
                          <!-- <div class="xiang">{{item.allStaffcount}}位</div> -->
                            <div class="flexc-cen-x">
                               <i class="el-icon-edit" style="color:white" v-if="q2 == false"></i>
                                <i class="el-icon-edit" style="color:#808080" v-if="q2 == true" @click="handlePassword(item)"></i>
                                <!-- <i class="el-icon-document-copy" style="color:#808080;margin-left:10px"></i> -->
                                <i class="el-icon-delete" style="color:#808080;margin-left:10px" v-if="q3 ==true" @click="toDel(item)"></i>
                            </div>
                        </div>
                    </div>
 
                </div>
                <div v-if="item.ID != active" class="flex-xy cursor shadow" id="shadw" style="width:96%;margin-left:2%;border-radius:5px">
                    <div style="width:95%;padding-top:10px;padding-bottom:10px">
                        <div class="flex-spc-x" @click="toChoose(item)" > 
                            <div class="flexc-cen-x">
                                <i class="el-icon-s-unfold"></i>
                                <div style="font-size:15px;margin-left:7px">{{item.ProjectTypeName}}</div>
                            </div>
                        </div>
                        <div class="flex-spc-x" >
                          <div class="" @click="toChoose(item)" style="width:250px;height:16px;padding-top:10px"></div>
                            <div class="flexc-cen-x" style="padding-top:10px">
                                <i class="el-icon-edit" style="color:#808080" v-if="q2 == true" @click="handlePassword(item)"></i>
                                <!-- <i class="el-icon-document-copy" style="color:#808080;margin-left:10px"></i> -->
                                <i class="el-icon-delete" style="color:#808080;margin-left:10px" v-if="q3 ==true" @click="toDel(item)"></i>
                            </div>
                        </div>
                    </div>
 
                </div>
              </div>
            </div>
        </el-aside>
         <el-main>
             <div class="flex-spc-x" style="width:100%;">
                 <div class="padding-left:5px" style="font-size:15px"> </div>
                 <div><el-button size="mini" type="primary" icon="el-icon-plus" v-if="q4 ==true" @click="handleEdit()">添加{{WZXMName}}</el-button>
                  <el-button size="mini" type="success" v-if="tableData.length > 1 && q7 == true" @click="toSort()">排序</el-button>
                  <el-button size="mini" type="warning"   @click="toshelves()">下架{{WZXMName}}</el-button>

                  </div>
             </div>
             <div  style="margin-top:30px;width:100%;">
               <div class="flex-xy" v-if="tableData.length == 0">
                 <img src="../../assets/zanwu.png" alt="" style="width:100px;height:100px">
                 <div style="margin-top:20px;color:#808080">暂无数据</div>
               </div>
               <div class="box cursor" v-for="(items,index) in tableData" >
                 <div  @click="handleEdit(items)" class="offline___NHq4e1" style="margin-left:5px;color:#7e7e7e" v-if="RowTypeList.length != 1">{{items.RowTypeName}}</div>
                 <div @click="handleEdit(items)" class="offline___NHq4e">{{items.ProjectTypeName}}</div>
              
                  <div @click="handleEdit(items)" class="main" style="width:100%;margin-top:3px">
                       <div class="flexc-cen-x" style="width:100%">
                         <img :src="items.HeadUrl" alt="" style="width:30px;height:30px;border-radius:100%">
                          <span class="titleMain" style="margin-left:5px">{{items.ProjectName}}</span>
                          <div class="kuai" :style="{'background':items.color}"></div>
                          <!-- <div class="jingp" v-if="items.ishot == 1"><img src="../../assets/fire.png" style="width:20px;height:20px" alt=""></div> -->
                          <!-- v-if="items.isjp == 1" -->
                       </div> 
                       <div class="content" style="margin-top:5px;width:80%">
                          <div>时长：{{items.Timelength}}分钟</div>
                           <div>价格：¥{{items.Amount}}</div>
                            <div class="textover" >简介：
                              <span v-if="items.ProjectIntroduction !='' ">{{items.ProjectIntroduction}}</span>
                              <span v-if="items.ProjectIntroduction =='' ">暂无</span>
                            </div>
                       </div>

                  </div>
                  <div class="flexc-cen-x look" @click="toLook(items)">
                    <i class="el-icon-view"></i>
                    <div>评价</div>
                  </div>
               </div>
                
             </div>
         </el-main>
    </el-container>

    <!--列表-->

    <!-- 分页组件 -->
    
    <el-drawer :wrapperClosable= false :title="'下架'+WZXMName"   :visible.sync="shelvesSure" :direction="direction" size="30%">
       <div style="width:100%;height:80vh;overflow:auto">
          <div  v-for="(item,index) in ListProjectshelves" class="heng flex-xy" style="width:80%">
          <div class="flex-spc-x" style="width:99%">
            <div class="flexc-cen-x">
              <img :src="item.HeadUrl" v-if="item.HeadUrl !='' " style="width:40px;height:40px;border-radius:100%" alt="">
              <img v-if="item.HeadUrl =='' " src="../../assets/img/head.png" style="width:40px;height:40px;border-radius:100%" alt="">
                    <div style="font-size:15px;margin-left:5px">{{item.ProjectName}}</div>
            </div>
            <div>
              <el-button  size="mini"   type="primary" plain @click="editshelves(item)">上架</el-button>
             </div>
          </div>
          </div> 
       </div>
       
        <div class="demo-drawer__footer flex-r-x" style="width:30%">
            <el-button size="small" @click="closeDialog">取消</el-button>
            <el-button
            style="margin-right:20px"
              size="small"
              type="primary"
              @click="closeDialog"
              >确定</el-button
            >
        </div>
     </el-drawer>
    <!-- 编辑界面 -->
     <el-drawer :wrapperClosable= false title="排序" :visible.sync="sortSure" :direction="direction" size="30%">
       <div style="width:100%;height:80vh;overflow:auto">
          <div  v-for="(item,index) in tableData" class="heng flex-xy" style="width:80%">
          <div class="flex-spc-x" style="width:99%">
            <div class="flexc-cen-x">
              <img :src="item.HeadUrl" v-if="item.HeadUrl !='' " style="width:40px;height:40px;border-radius:100%" alt="">
              <img v-if="item.HeadUrl =='' " src="../../assets/img/head.png" style="width:40px;height:40px;border-radius:100%" alt="">
                    <div style="font-size:15px;margin-left:5px">{{item.ProjectName}}</div>
            </div>
            <div>
              <el-button v-show="index !=0" size="mini" icon="el-icon-top"  type="primary" plain @click="toTop(item)">升序</el-button>
              <el-button  v-show="index != tableData.length - 1 " size="mini" icon="el-icon-bottom" type="success" plain @click="toDown(item)">降序</el-button>
            </div>
          </div>
          </div> 
       </div>
       
        <div class="demo-drawer__footer flex-r-x" style="width:30%">
            <el-button size="small" @click="closeDialog">取消</el-button>
            <el-button
            style="margin-right:20px"
              size="small"
              type="primary"
              @click="closeDialog"
              >确定</el-button
            >
        </div>
     </el-drawer>


    <el-drawer :wrapperClosable= false :title="title" :visible.sync="editFormVisible" :direction="direction" size="40%">
      <el-tabs v-model="activeName"  style="padding-left:10px;padding-right:10px;padding-bottom:150px">
        <el-tab-pane label="基础配置" name="first">      
        <el-form label-width="100px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item :label="WZXMName+'名称:'" prop="ProjectName">
          <el-input size="small" v-model="editForm.ProjectName" auto-complete="off" placeholder="请输入名称"  style="width: 215px"></el-input>
        </el-form-item>
        <el-form-item :label="WZXMName+'编号:'" prop="ProjectNO" v-if="isCashier == 1">
          <el-input size="small" v-model="editForm.ProjectNO" auto-complete="off" placeholder="请输入编号"  style="width: 215px"></el-input>
        </el-form-item>
        
          <el-form-item :label="WZXMName+'类别:'" prop="ProjectTypeID" >
            <el-select v-model="editForm.ProjectTypeID" placeholder="请选择" size="small">
                <el-option
                  v-for="item in typeList"
                  :key="item.ID"
                  :label="item.ProjectTypeName"
                  :value="item.ID">
                </el-option>
              </el-select>
              <el-button type="text" @click="toSetting">设置</el-button>
           </el-form-item>
          
          <el-form-item :label="WZXMName+'头像:'" prop="HeadUrl">
                <div class="list-img-box cursor">
                  <div v-if="editForm.HeadUrl !== ''">
                    <img
                      :src="editForm.HeadUrl"
                      style="width: 100px; height: 100px"
                      alt="图片"
                        @click="uploadPicture('HeadUrl')"
                    />
                  </div>
                  <div
                    v-else 
                    class="upload-btn"
                    style="height: 100px;width:100px"
                    @click="uploadPicture('HeadUrl')"
                  >
                    <!-- <i class="el-icon-plus" style="font-size: 30px"></i> -->
                                     <div class="flex-xy">
                       <i class="el-icon-plus coBlue" style="font-size: 25px"></i>
                        <span class="coBlue" style="font-size:13px;margin-top:-10px ">上传</span>
                  </div>

                    <!-- <span>封面设置</span> -->
                  </div>
                </div>
                <input
                  type="hidden"
                  v-model="editForm.HeadUrl"
                  placeholder="请添加头像"
                />
          </el-form-item>
          <el-form-item :label="WZXMName+'种类:'" v-if="title == '添加' && RowTypeList.length != 1"  prop="RowTypeID">
            <el-select v-model="editForm.RowTypeID"  placeholder="请选择" size="small">
                  <el-option
                    v-for="item in RowTypeList"
                    :key="item.ID"
                    :label="item.RowTypeName"
                    :value="item.ID">
                  </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="WZXMName+'种类:'" v-if="title == '修改' && RowTypeList.length != 1"  prop="RowTypeID">
            <el-select v-model="editForm.RowTypeID" disabled  placeholder="请选择" size="small">
                  <el-option
                    v-for="item in RowTypeList"
                    :key="item.ID"
                    :label="item.RowTypeName"
                    :value="item.ID">
                  </el-option>
            </el-select>
          </el-form-item>

          <el-form-item :label="WZXMName+'颜色:'" prop="color">         
            <div class="bgColor flexc-cen-x" :style="{'background':editForm.color,}" @click="toColor">
                <i class="el-icon-arrow-down" style="margin-left:90%"></i>
            </div>
          </el-form-item>
          <el-form-item label="关联卡种:" prop="CardIDs" v-if="isCard == 1 && iskczk ==0">
            <el-select v-model="editForm.CardIDs" multiple placeholder="请选择" size="small" style="width:90%">
              <el-option
                v-for="item in cardList"
                :key="item.ID"
                :label="item.CardName"
                :value="item.ID">
              </el-option>
            </el-select>
            <el-button type="text" @click="toCard">设置</el-button>
          </el-form-item>
          <el-form-item label="消耗金额：" prop="xhAmount" v-if="iszjyy == 1 ">
          <el-input v-model="editForm.xhAmount" size="small" type="number"   style="width:150px;"></el-input> 元
        </el-form-item>
        <el-form-item label="消耗次数：" prop="iscx" v-if="iszjyy == 1">
          <el-input v-model="editForm.xhnumber" size="small" type="number"   style="width:150px;"></el-input> 次
        </el-form-item>
          <div  v-if="isCard == 1  && iskczk ==0" style="color:#b3b3b3;margin-top:-10px;margin-bottom:20px;margin-left:100px"> 如果不选择卡种，默认使用所有卡种。</div>

          <el-form-item label="关联员工：" v-if="iszjyy == 1" prop="StaffNames">
              <el-button type="text" @click="addeacherIDs">选择员工</el-button>
                 <br> 
           <span >{{editForm.StaffNames}}</span> 
        </el-form-item>
          <el-form-item label="关联卡种:" prop="CardIDs" v-if="isCard == 1 && iskczk >0">
             <el-button type="default" size="mini" @click="toCard1">添加会员卡</el-button>
            <div class="g-items-wrap f-mt-10 " >
                <div class="itemWrap___33SF3"  v-for="item in ListProjectCard" :key="item.index" :id="item.ID" >
                    <span >{{item.CardName}} &nbsp;
                    <span v-if="item.CardType =='1'">次卡</span>
                    <span v-if="item.CardType =='2'">次卡</span>
                    <span v-if="item.CardType =='3'">期限卡</span>
                    <span v-if="item.CardType =='4'">储蓄卡</span>
                    <span v-if="item.CardType =='5'">储蓄卡</span>
                    </span> &nbsp;
                    <span v-if="(item.CardType =='1' || item.CardType =='2') && item.YHvalue>0 ">{{item.YHvalue}}次</span>
                    <span v-if="item.CardType =='4' || item.CardType =='5'">{{item.YHvalue}}折</span>
                 </div>
            </div>
          </el-form-item>
          <div  v-if="isCard == 1  && iskczk >0" style="color:#b3b3b3;margin-top:-10px;margin-bottom:20px;margin-left:100px"> 如果不选择卡种，默认使用所有卡种。</div>
          <el-form-item label="价格:" prop="Amount" >
          <el-input size="small" v-model="editForm.Amount" type="number" auto-complete="off" placeholder="请输入价格"  style="width: 215px"></el-input> 元
          </el-form-item>
          <el-form-item label="最大预约人数:"  v-if="iskcrs==1" prop="RenInfo" >
          <el-input size="small" v-model="editForm.RenInfo" type="number" auto-complete="off" placeholder="请输入预约人数"  style="width: 215px"></el-input> 人
          </el-form-item>
         <div  v-if="iskcrs == 1" style="color:#b3b3b3;margin-top:-10px;margin-bottom:20px;margin-left:100px"> 最大预约人数输入0则为不受限</div>

          <el-form-item :label="WZXMName+'时长:'" prop="Timelength">
          <el-input-number v-model="editForm.Timelength" size="small" :step="1" step-strictly ></el-input-number> 分钟
          </el-form-item>


        <el-form-item label="上架:" prop="isshelves">
            <el-radio-group v-model="editForm.isshelves">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>


        <el-form-item label="轮播图:" prop="mainImage">
            <div class="flexc-cen-x">
                <div class="list-img-box cursor">
                  <div v-if="img1 !== ''">
                    <img
                      :src="img1"
                    style="width: 121px; height: 81px"
                      alt="图片"
                       @click="uploadPicture('img1')"
                    />
                    <div class="flex-xy">
                  <el-button  title="删除"  @click="delimglb(1)"  size="mini"  type="danger" icon="el-icon-delete" ></el-button>
                   </div>
                  </div>
                  <div
                    v-else 
                    class="upload-btn"
                    style="height: 100px;width:100px"
                    @click="uploadPicture('img1')"
                  >
                    <!-- <i class="el-icon-plus" style="font-size: 30px"></i> -->
                         <div class="flex-xy">
                       <i class="el-icon-plus coBlue" style="font-size: 25px"></i>
                        <span class="coBlue" style="font-size:13px;margin-top:-10px ">上传</span>
                  </div>

                    <!-- <span>封面设置</span> -->
                  </div>
                </div>
                <div class="list-img-box cursor" style="margin-left:10px">
                  <div v-if="img2 !== ''">
                    <img
                      :src="img2"
                      style="width: 121px; height: 81px"
                      alt="图片"
                        @click="uploadPicture('img2')"
                    />
                    <div class="flex-xy">
                  <el-button  title="删除"  @click="delimglb(2)"  size="mini"  type="danger" icon="el-icon-delete" ></el-button>
                   </div>
                  </div>

                  <div
                    v-else 
                    class="upload-btn"
                    style="height: 100px;width:100px"
                    @click="uploadPicture('img2')"
                  >
                    <!-- <i class="el-icon-plus" style="font-size: 30px"></i> -->
                       <div class="flex-xy">
                       <i class="el-icon-plus coBlue" style="font-size: 25px"></i>
                        <span class="coBlue" style="font-size:13px;margin-top:-10px ">上传</span>
                  </div>

                    <!-- <span>封面设置</span> -->
                  </div>
                </div>
                <div class="list-img-box cursor" style="margin-left:10px">
                  <div v-if="img3 !== ''">
                    <img
                      :src="img3"
                      style="width: 121px; height: 81px"
                      alt="图片"
                       @click="uploadPicture('img3')"
                    />
                    <div class="flex-xy">
                  <el-button  title="删除"  @click="delimglb(3)"  size="mini"  type="danger" icon="el-icon-delete" ></el-button>
                   </div>
                  </div>
                  <div
                    v-else 
                    class="upload-btn"
                    style="height: 100px;width:100px"
                    @click="uploadPicture('img3')"
                  >
                    <!-- <i class="el-icon-plus" style="font-size: 30px"></i> -->
                    
                  <div class="flex-xy">
                       <i class="el-icon-plus coBlue" style="font-size: 25px"></i>
                        <span class="coBlue" style="font-size:13px;margin-top:-10px ">上传</span>
                  </div>
                    <!-- <span>封面设置</span> -->
                  </div>
                </div>
            </div>
                <!-- <input
                  type="hidden"
                  v-model="formValidate.mainImage"
                  placeholder="请添加轮播图"
                /> -->
          </el-form-item>
        <el-form-item :label="WZXMName+'简介:'" prop="ProjectIntroduction">
           <el-input type="textarea" :rows="2" placeholder="请输入简介" v-model="editForm.ProjectIntroduction" style="width:90%"></el-input>
        </el-form-item>
        </el-form>
      </el-tab-pane>
        <el-tab-pane label="更多设置" name="second">
          <el-form label-width="100px"  >
            <!-- <el-form-item label="精品:" prop="isjp">
            <el-radio-group v-model="editForm.isjp">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
           </el-form-item>
            <el-form-item label="热门:" prop="ishot">
            <el-radio-group v-model="editForm.ishot">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
           </el-form-item> -->
            <el-form-item label="达到效果:" prop="TrainingEffect">
             <el-input size="small" v-model="editForm.TrainingEffect" auto-complete="off" placeholder="请输入达到效果"  style="width: 215px"></el-input>
            </el-form-item>
            <el-form-item label="适合人群:" prop="SuitsTheCrowd">
             <el-input size="small" v-model="editForm.SuitsTheCrowd" auto-complete="off" placeholder="请输入适合人群"  style="width: 215px"></el-input>
            </el-form-item>
            <el-form-item label="注意事项:" prop="MattersNeedingAttention">
              <el-input el-input type="textarea" :rows="2" placeholder="请输入注意事项" v-model="editForm.MattersNeedingAttention" style="width:90%"></el-input>
            </el-form-item>
          </el-form>

        </el-tab-pane>
        <el-tab-pane label="图文详情" name="third">
            <Editor :key="timer" v-show="activeName == 'third'" v-bind:value="editForm.GraphicDetails" v-model="editForm.GraphicDetails"  style="margin-bottom:150px;margin-top:-10px">
            </Editor>
        </el-tab-pane>
        <el-tab-pane :label="name1+'设置'" name="forth" v-if="iszjyy == 1">
          <el-form label-width="130px">
            <el-form-item :label="'开启'+name1+'资料:'" prop="isPreAboutInfo">
              <el-radio-group v-model="editForm.isPreAboutInfo" >
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="开启线上支付:" prop="isPay" v-if="IsPay == 1 && xmIsPay == 1 && editForm.isPreAboutInfo == 1" >
                <el-radio-group v-model="editForm.isPay">
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="0">否</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="线上支付价格:" prop="PayAmount" v-if="editForm.isPay == 1 && editForm.isPreAboutInfo == 1" >
              <el-input size="small" v-model="editForm.PayAmount" type="number" auto-complete="off" placeholder="请输入价格"  style="width: 215px"></el-input> 元
            </el-form-item>
            <el-form-item label="允许无卡预约:" prop="isWKYY" v-if="editForm.isPreAboutInfo == 1"  >
                <el-radio-group v-model="editForm.isWKYY">
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="0">否</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="允许选择员工:" prop="isStaff" v-if="editForm.isPreAboutInfo == 1"  >
                <el-radio-group v-model="editForm.isStaff">
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="0">否</el-radio>
                </el-radio-group>
            </el-form-item>
            
            <el-form-item label="预约时间间隔：" v-if="editForm.isPreAboutInfo == 1" prop="Timelengthqt"  >
          <el-select v-model="editForm.TimelengthSJ" placeholder="请选择" size="small" style="width:150px;" >
                <el-option
                  v-for="item in timechoose"
                  :key="item.value"
                  :label="item.value"
                  :value="item.value">
                </el-option>
              </el-select>
              分钟
           </el-form-item>

            <el-form-item :label="name1+'资料:'" v-if="editForm.isPreAboutInfo == 1">
              <el-button bian type="text"  @click="openPreAbout()">编辑</el-button>
            </el-form-item>
            <div  v-for="(items,index) in editForm.ListPreAboutForms" v-if="items.state !=3 && editForm.isPreAboutInfo == 1" style="margin-bottom:15px;">
              <div>
                <span v-if="items.isbt == 1" style="margin-left:5%;color:red">*</span>
                <span v-if="items.isbt == 0" style="margin-left:5%;color:white">*</span>
                <span>{{items.Title}}<span v-if="items.fType == 1" ><i class="el-icon-s-order" style="margin-left:4px"></i>:</span>
                <span v-if="items.fType == 2"><i class="el-icon-s-grid" style="margin-left:4px"></i>：</span></span>
              </div>
            </div>
          </el-form>
        </el-tab-pane>
      </el-tabs>

        <div class="demo-drawer__footer flex-spc-x"  style="width:40%">
          <div>
         <el-button
           v-if="title == '修改' && q6 ==true"
            style="margin-left:20px"
            size="small"
            type="danger"
            @click="delForm()"  
            >删除</el-button
          >
          </div>
  <div>

          <el-button size="small" @click="closeDialog">取消</el-button>
          
          <el-button
          style="margin-right:20px"
            size="small"
            type="primary"
            @click="submitForm('editForm')"
            >保存</el-button
          >
  </div>
         
        </div>
    </el-drawer>
    <!-- </el-dialog> -->
    <el-dialog :title="title1" :visible.sync="passShow" width="40%" >
      <el-form label-width="120px" >
        <el-form-item :label="WZXMName+'类别'" prop="ProjectTypeName">
          <el-input size="small" placeholder="请输入类别" v-model="ProjectTypeName" auto-complete="off"></el-input>
        </el-form-item>
      
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="passShow = false">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" @click="subProjectTypeName()">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog title="选择颜色" :visible.sync="colorShow" width="500px" >
        <div style="height:300px;overflow:auto;">
            <div class="bgColor" v-for="(item,index) in colorList" :style="{'background':item,'width':'80%','margin-top':'15px','margin-left':'10%'}" @click="toChooseColor(item)"> 
            </div>
        </div>
        
    </el-dialog>
    
    <el-dialog :title="name1+'资料'" :visible.sync="preShow" width="800px" >
      <div class="flex-spc-x" style="width:98%;margin-left:1%;height:400px">
        <div class="right" style="height:100%;width:27%" > 
            <div class="flex-xy"  style="margin-bottom:20px">通用格式</div>
            <el-button plain class="el-icon-s-order" @click="toadd('1')"> 文本</el-button>
            <el-button plain class="el-icon-s-grid" @click="toadd('2')"> 时间</el-button>
        </div>
        <div class="left flex-xy" style="width:73%;height:100%">
            <div class="mainTitle">
                <div class="" style="font-size:20px;margin-left:5px;margin-top:5px;font-weight:500">{{name1}}资料</div>
                <div  class="mian" style="margin-top:10px;width:100%" :key="timer" @dragover="dragover($event)">
                  <transition-group class="transition-wrapper" name="sort">
                    <div v-for="(items,index) in ListPreAboutForms" class="hen flex-xy" :key='items.length' v-if="items.state != 3" style="margin-top:10px"   
                      :draggable="true"
                      @dragstart="dragstart(items)"
                      @dragenter="dragenter(items,$event)"
                      @dragend="dragend(items,$event)"
                      @dragover="dragover($event)">
                      <div class="flex-spc-x" style="font-size:15px;width:100%;">
                        <span v-if="items.fType == 1" style="margin-left:5%">文本</span>
                        <span v-if="items.fType == 2" style="margin-left:5%">时间</span>
                        <i class="el-icon-delete-solid coBlue" style="margin-right:2%;font-size:15px" @click="todel(items,index)"></i>
                        <!-- <el-button size="mini" style="margin-right:10px" type="info" @click="todel(items,index)">删除</el-button> -->
                      </div>
                      <div class="flexc-cen-x"  style="margin-top:5px">
                        <el-select v-model="items.isbt" placeholder="选择" size="mini" style="width:80px">
                          <el-option
                            v-for="item in lay"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                        <el-input size="mini" v-model="items.Title" placeholder="请输入标题" style="width:350px;margin-left:10px"></el-input>
                      </div>
                     
                    </div>
                  </transition-group>
                  
                </div>
   
            </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading"  @click="save()">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog
              title="裁切封面"
              :visible.sync="cropperModel"
              width="1200px"
              center
            >
             <cropper-image
                :Name="cropperName"
                @uploadImgSuccess="handleUploadSuccess"
                ref="child"
                :key="timer"
              >
              </cropper-image> 
    </el-dialog>
            <!--查看大封面-->
    <el-dialog title="查看大封面" :visible.sync="imgVisible" center>
        <img
          :src="imgName"
          v-if="imgVisible"
          style="width: 100%"
          alt="查看"
        />
    </el-dialog>
     <el-dialog title="类别" :visible.sync="vipShow" width="600px" @click="vipShow = false">
       <div class="flex-spc-x" style="margin-top:-20px">
         <div></div>
          <el-button size="mini" type="primary" icon="el-icon-plus"  v-if="q1 == true"  @click="handlePassword()">添加{{WZXMName}}类别</el-button>
       </div>
        
      <el-table  :data="typeList" highlight-current-row v-loading="loading" size="mini"  element-loading-text="拼命加载中" style="width:100%;margin-top:10px">
        <el-table-column  prop="ProjectTypeName" label="类别名称">
            
        </el-table-column>
      <el-table-column align="center" label="操作" width="200" >
        <template slot-scope="scope">
          <el-button size="mini" @click="handlePassword(scope.row)" >编辑</el-button>
          <el-button size="mini" type="info" v-if="q3 ==true" @click="toDel(scope.row)" >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
     </el-dialog>
     <el-dialog
      title="选择会员卡"
      :visible.sync="dialoglaoshiVisible"
      width="40%"
        >
            <el-table :data="cardList" ref="docTable" :row-key="(row) => {return row.ID}" :header-cell-style="{'background-color':'#f8f8f8'}" style="width:100%;margin-top:10px;" @selection-change="handleSelectionChange" >
              <el-table-column type="selection" width="55" > </el-table-column>
                <el-table-column label="会员卡名称" prop="CardName" ></el-table-column>
                <el-table-column label="会员卡类型" prop="CardType" >
                  <template slot-scope="scope">
                    <span v-if="scope.row.CardType =='1'">次卡（有限期）</span>
                    <span v-if="scope.row.CardType =='2'">次卡（无限期）</span>
                    <span v-if="scope.row.CardType =='3'">期限卡</span>
                    <span v-if="scope.row.CardType =='4'">储蓄卡（无期限）</span>
                    <span v-if="scope.row.CardType =='5'">储蓄卡（有限期）</span>
                  </template>
                </el-table-column>

             </el-table> 
             
   
          <span slot="footer" class="dialog-footer1">
              <el-button type="primary"  @click="doxuanhao">确 定</el-button>
        <el-button @click="dialoglaoshiVisible = false">取 消</el-button>
        
        </span>
      
    </el-dialog>
    <el-dialog
      title="选择员工"
      :visible.sync="dialogyuangongVisible"
      width="40%"
        >
            <el-table :data="StaffList" ref="tableData" :row-key="(row) => {return row.ID}" :header-cell-style="{'background-color':'#f8f8f8'}" style="width:100%;margin-top:10px;" @selection-change="handleSelectionygChange" >
              <el-table-column type="selection" width="55" > </el-table-column>
                 <el-table-column label="员工姓名" prop="Name" ></el-table-column>
                <el-table-column label="手机号" prop="Phone" ></el-table-column>

             </el-table>   
   
          <span slot="footer" class="dialog-footer1">
              <el-button type="primary"  @click="doxuanhaoyg">确 定</el-button>
        <el-button @click="dialogyuangongVisible = false">取 消</el-button>
        
        </span>
      
    </el-dialog>
    
 <el-dialog
      title="选择会员卡"
       :visible.sync="dialogcardVisible"
      width="40%"
        ><div class="flex-spc-x" style="margin-top:-30px">
      <div></div>
     <el-button size="mini" type="primary" @click="choosePro()">选择会员卡</el-button>
    </div>
             <el-table :data="ListProjectCard"  :row-key="(row) => {return row.ID}" :header-cell-style="{'background-color':'#f8f8f8'}" style="width:100%;margin-top:10px;"  >
           
                <el-table-column label="会员卡名称" prop="CardName" ></el-table-column>
                <el-table-column label="会员卡类型" prop="CardType" >
                  <template slot-scope="scope">
                    <span v-if="scope.row.CardType =='1'">次卡（有限期）</span>
                    <span v-if="scope.row.CardType =='2'">次卡（无限期）</span>
                    <span v-if="scope.row.CardType =='3'">期限卡</span>
                    <span v-if="scope.row.CardType =='4'">储蓄卡（无期限）</span>
                    <span v-if="scope.row.CardType =='5'">储蓄卡（有限期）</span>
                  </template>
                </el-table-column>
                <el-table-column v-if="iskczk==2" label="次数" prop="YHvalue"  >
                    <template slot-scope="scope" class="flexB">
                      <span v-if=" (scope.row.CardType =='1' || scope.row.CardType =='2') && scope.row.YHType==2 && scope.row.state1==0">
                        <span v-if="scope.row.YHvalue>0">
                          {{scope.row.YHvalue}}次
                        </span>
                        <span v-else>排课次数</span>
                        </span>
                       <el-input  v-if="(scope.row.CardType =='1' || scope.row.CardType =='2') && scope.row.YHType==2 && scope.row.state1==1" v-model="scope.row.YHvalue" placeholder="次数" style="width:100px;"></el-input>  
                    </template>
               </el-table-column>
                <el-table-column label="折扣" prop="YHvalue"  >
                    <template slot-scope="scope" class="flexB">
                      <span v-if=" (scope.row.CardType =='4' || scope.row.CardType =='5') && scope.row.YHType==1 && scope.row.state1==0">{{scope.row.YHvalue}}折</span>
                       <el-input  v-if="(scope.row.CardType =='4' || scope.row.CardType =='5') && scope.row.YHType==1 && scope.row.state1==1" v-model="scope.row.YHvalue" placeholder="折扣" style="width:100px;"></el-input>  
                    </template>
               </el-table-column>
               <el-table-column label="操作" align="center"  width="180">
                   <template slot-scope="scope" class="flexB">
                        <el-button type="primary" size="medium" @click="editsaverClick(scope.row)" v-if=" scope.row.state1==1 ">保存</el-button>
                        <el-button type="default"  @click="editcancelClick(scope.row)" v-if="  scope.row.state1==1 ">取消</el-button>
                        <el-button type="text" v-if="scope.row.state1==0" @click="editCardClick(scope.row)"  >修改</el-button>
                        <el-button type="text"  v-if="scope.row.state1==0" @click="delCardClick(scope.row)"  >删除</el-button>
                    </template>
               </el-table-column>
             </el-table> 
             
   
          <span slot="footer" class="dialog-footer1">
              <el-button type="primary"  @click="dialogcardVisible = false">确 定</el-button>
         
        </span>
      
    </el-dialog>


    
  </div>
</template>

<script>

import CropperImage from "../../components/CropperImage";
import  Editor from '../../components/editor'

import {getListManageLogin,addManageLogin,delManageLogin,editManageLogin,editManageLoginmoney,editManageLoginPwd,editManageLoginIsdisable} from "@/api/getData";
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      title1:'',
      DianList:[],
      oldData:null, // 开始排序时按住的旧数据
      newData:null,// 拖拽过程的数据
      preShow:false,
      cropperModel: false,
      dialoglaoshiVisible: false,
      dialogyuangongVisible: false,
      dialogcardVisible: false,
      cropperName: "",
      listCardIDs: "",
      ProjectID: "",
      colorShow:false,
      imgName: "",
      timechoose:[
          {
          value:15,
        },
        {
          value:30,
        },
        {
          value:45,
        },
        {
          value:60,
        } 
      ],
      multipleSelection:[],
      ListProjectCard:[],
       imgVisible: false,
      formValidate: {
        mainImage: "",
      },
      cardList:[],
      timer:'',
      value:'1',
      vipShow:false,
      colorList:[
          '#9c4b4b',
          '#db6a51',
          '#b07187',
          '#da8e6d',
          '#b0a763',
          '#9583b0',
          '#5b6fc1',
          '#a6c399',
          '#9c8088',
          '#FEFF99',
          '#FBB0A1',
          '#BCFD84',
          '#95E2F5',
          '#928FD9',
          '#47D95E',
          '#E5D0C4',
          '#f5c856',
          '#75c090',
          '#ed707a',
          '#b0649a',
          '#d19fc9',
          '#8b9599',
      ],
      q1:false,
      q2:false,
      q3:false,
      q4:false,
      q5:false,
      q6:false,
      q7:false,
      q8:false,
      IsPay:localStorage.getItem("IsPay"),
      hyIsPay:localStorage.getItem("hyIsPay"),
      spIsPay:localStorage.getItem("spIsPay"),
      gkIsPay:localStorage.getItem("gkIsPay"),
      hdIsPay:localStorage.getItem("hdIsPay"),
      xmIsPay:localStorage.getItem("xmIsPay"),
      iskczk:localStorage.getItem("iskczk"),
      iskcrs:localStorage.getItem("iskcrs"),
      typeName:'',
      RowTypeList:[],
      name:'全部',
      id:'',
      active:'',
      img1:'',
      img2:'',
      img3:'',
      activeName: 'first',
      SelectStoresID:localStorage.getItem("StoresID"),
      direction: "ltr",
      passShow:false,
      money:'',
      input:'',
      timer:'',
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      chongShow:false,
      title: '添加',
      iseditcard:false,
      ProjectCardID:'',
      tableData:[],
      sortSure:false,
      shelvesSure:false,
      ProjectTypeName:'',
      TeacherIDs:'',
      isTeacher:false,
      ListPreAboutForms:[],
      options:[],
      iszjyy:"",
      lay:[
        {
          value:'1',
          label:'必填'
        },
            {
          value:'0',
          label:'选填'
        }
      ],
      // rowType:[
      //    {
      //     value:'1',
      //     label:'班课'
      //   },
      //       {
      //     value:'2',
      //     label:'私教'
      //   },
      //    {
      //     value:'3',
      //     label:'精品课'
      //   }
      // ],
      Pwd:'',
      typeList:[],
      Limits:[],
      editForm: {
        color:'#b0649a',
        Timelength:60,
        isjp:0,
        ishot:0,
        isPreAboutInfo:0,
        PayAmount:0,
        isWKYY:0,
        isStaff:1,
        TimelengthSJ:30,
        ProjectName:'',
        isshelves:1,
        HeadUrl:'',
        Amount:0,
        ProjectTypeID:'',
        CardIDs:'',
        isPay:0,
        xhAmount:'' ,
        xhnumber:'',
        RenInfo:1,
        token: localStorage.getItem('token'),
        ListPreAboutForms:[],
        ListProjectCard:[],
        StaffIDs:'',
        StaffNames:'',
      },
      // rules表单验证
      isCard:localStorage.getItem('isCard'),
      rules: {
        // ProjectNO: [{ required: true, message: '请输入编号', trigger: 'blur' }],
        ProjectName: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        ProjectTypeID:[{ required: true, message: '请选择类别', trigger:  'blur' }],
        HeadUrl: [{ required: true, message: '请选择头像', trigger: 'blur' }],
        RowTypeID: [{ required: true, message: '请选择种类', trigger: 'blur' }],
      },
  name1:'',
      formInline: {
        page: 1,
        limit: 10,
        varLable: '',
        varName: '',
        token: localStorage.getItem('logintoken')
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      ProjectCarddata: {
        ID: '',
        CardID: '',
        YHType: '',
        YHvalue: '',
        state: '',
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      StaffList: [],
      multipleSelectionyg: [],
      ListProjectshelves: [],
      // 分页参数
          WZYGName:'',
    WZHYName:'',
    WZXMName:'',
    WZPBName:'',
    isCashier:'',
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Editor,
    Pagination,
    CropperImage,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.WZYGName = localStorage.getItem('WZYGName')
    this.WZHYName = localStorage.getItem('WZHYName')
    this.WZXMName = localStorage.getItem('WZXMName')
    this.WZPBName = localStorage.getItem('WZPBName')
    this.iszjyy = localStorage.getItem('iszjyy')
    this.name1 = localStorage.getItem('zzjy') 
    this.isCashier = localStorage.getItem('isCashier')
      if(localStorage.getItem('StoresType')== 1){
          this.typeName = '签到'
        
      }  else {
          this.typeName = '核销'
        
      }     
      if(localStorage.getItem('isAdmin') == 1){
          this.q1 = true
          this.q2 = true
          this.q3 = true
          this.q4 = true
          this.q5 = true
          this.q6 = true
          this.q7 = true
          this.q8 = true
      }
    this.Limits = localStorage.getItem('Limits')
      this.Limits = this.Limits.split(',')
      this.Limits.forEach(items => {
            if(items == 62){
              this.q1 = true
            }
            if(items == 63){
              this.q2 = true
            }
            if(items == 64){
              this.q3 = true
            }
            if(items == 65){
              this.q4 = true
            }
            if(items == 66){
              this.q5 = true
            }
            if(items == 67){
              this.q6 = true
            }
            if(items == 68){
              this.q7 = true
            }
          
    })

    this.getType()
    this.getList()
    this.getRowType()
    this.getCardType()
    this.getDianList()
    this.getCardList()
  
      // this.getList()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    toLook(row){
      this.$router.push({
          path: `/project/appraise/${row.ID}`,
        });
    },
     toSetting(){
      this.getType()
      this.vipShow = true

    },
    toCard(){
          this.$router.push({ path: '/card/card'})
    },
    toCard1(){
      if(this.title == '修改'){
        this.iseditcard = true;

      }else{
        this.iseditcard = false;

       }
       this.dialogcardVisible=true;

     },choosePro(){
       this.dialoglaoshiVisible = true;
     },
    getRowType(){
       var data = { 
          SelectStoresID:this.SelectStoresID,        
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
      }
  
      var that = this
      this.ajax('getListRowTypeSetting.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
         
                that.RowTypeList= res.data
    
          } 
       })
    },addeacherIDs(){
                this.TeacherIDs = this.editForm.StaffIDs;
                this.isTeacher =false;
                 this.getListProjectStaff();
            },
            getListProjectStaff(){
      var data = {  
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          SelectStoresID:this.SelectStoresID,   
          StaffTypeID:0,
          selectName:""
      }
  
      var that = this
      this.ajax('getListProjectStaff.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
         
                that.StaffList= res.data
                that.dialogyuangongVisible =true;
                that.toggleSelection(that.StaffList);

    
          } 
       })

    },toggleSelection (rows) {
                 let arr = []
                 let allPermission = this.TeacherIDs.split(',');
 
                 rows.forEach(item => {
                    allPermission.forEach(element =>{
            

                 if (element === item.ID) {
                       arr.push(item)
                    }
                   })
                })
 
             if (arr) {
                   this.$nextTick(() => {
               arr.forEach(row => {
                 this.$refs.tableData.toggleRowSelection(row,true);
              });
              })
                } else {
                 this.$refs.tableData.clearSelection()
                }
            },doxuanhaoyg(){
      let arr = [];
                let arrname = [];
                this.multipleSelectionyg.forEach(element => {
                    arr.push(element.ID);
                    arrname.push(element.Name);
                });
                 if(arr.length>0){
                          
                         this.editForm.StaffIDs = arr.join();
                         this.editForm.StaffNames= arrname.join();
 
                   
                  
                }else{
                    
                         
                         this.editForm.StaffIDs="";
                         this.editForm.StaffNames= "";
 
                    
                }
                if(this.isTeacher){
                  this.editProjectStaffIDs();

                }else{
                  this.dialogyuangongVisible =false;


                }


    },editProjectStaffIDs(){
      var data = { SelectStoresID:this.SelectStoresID,        
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          ProjectID:this.editForm.ID,
          SelectStoresID:this.SelectStoresID, 
          StaffIDs:this.editForm.StaffIDs,
          
        }
        var that = this
        this.ajax('editProjectStaffIDs.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
             
            that.getListProjectCard()
             
            }

        })
    },handleSelectionygChange(val){
      this.multipleSelectionyg = val;
    },
    getCardList(){
      var data = { SelectStoresID:this.SelectStoresID,        
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          CardType:0
      }
  
      var that = this
      this.ajax('getListMemberCardYY.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
         
                that.cardList= res.data
    
          } 
       })

    }, 
    getListProjectCard(){
      var data = { SelectStoresID:this.SelectStoresID,        
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          ProjectID:this.ProjectID
      }
  
      var that = this
      this.ajax('getListProjectCard.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
         
                that.ListProjectCard= res.data
                that.listCardIDs =res.CardIDs
    
          } 
       })

    },editsaverClick(val){
         
         if(this.iseditcard){
          if(val.ID >0){

            this.editProjectCard(val);

          }else{
            val.state1 ="0";

          }
         }else{
           val.state1 ="0";
         }
      },
    editProjectCard(row){
      var data = { SelectStoresID:this.SelectStoresID,        
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          ProjectCardID:row.ID,
          YHType:row.YHType,
          YHvalue:row.YHvalue,
        }
        var that = this
        this.ajax('editProjectCard.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
             
              that.getListProjectCard()
             
            }

        })
    },editcancelClick(val){
         val.state1 ="0";
         if(this.iseditcard){
           
         }
      },editCardClick(val){
      val.state1 ="1";
      
    },delCardClick(row){
      if(this.iseditcard){
           this.ProjectCardID = row.ID;
           this.delProjectCard();
         }else{
            this.ListProjectCard.splice(this.ListProjectCard.indexOf(row),1)
         }
         
    },
    delProjectCard(){
      var data = { SelectStoresID:this.SelectStoresID,        
         
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          ProjectCardID:this.ProjectCardID,
         
        }
        var that = this
        this.ajax('delProjectCard.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
             
              that.getListProjectCard()
             
            }

        })
    } ,handleSelectionChange(val){
       this.multipleSelection = val;
    },doxuanhao(){
             let arr =[];
             var that =this;
                this.multipleSelection.forEach(element => {
                if(that.iskczk==2){
                  console.log("iskczk",that.iskczk);

                  if(element.CardType==1 || element.CardType==2){
                    console.log("CardType",element.CardType);

                    let  ProjectCarddata={
                                   ID: '0',
                                   CardID: element.ID,
                                   CardName:element.CardName,
                                   CardType: element.CardType,
                                   YHType: '2',
                                   YHvalue: '0',
                                   state: '1',
                                   state1: '0',
                           }
                           
                           console.log("ProjectCarddata",ProjectCarddata);

                         arr.push(ProjectCarddata);
                  }else{
                    console.log("CardType2",element.CardType);

                    let  ProjectCarddata={
                                   ID: '0',
                                   CardID: element.ID,
                                   CardName:element.CardName,
                                   CardType: element.CardType,
                                   YHType: '1',
                                   YHvalue: '10',
                                   state: '1',
                                   state1: '0',
                           }
                           
                          
                         arr.push(ProjectCarddata);
                  }
               

                }else{
                  console.log("CardType3",element.CardType);

                  let  ProjectCarddata={
                                   ID: '0',
                                   CardID: element.ID,
                                   CardName:element.CardName,
                                   CardType: element.CardType,
                                   YHType: '1',
                                   YHvalue: '10',
                                   state: '1',
                                   state1: '0',
                           }
                           
                          
                         arr.push(ProjectCarddata);
                }
                    
                    });

 
                    this.ListProjectCard.forEach(element => {
                            arr.forEach(element1 => {
                              if(element.CardID == element1.CardID){
                                element1.YHType= element.YHType
                                element1.YHvalue= element.YHvalue
                              }
                           });
                        });

 

                   this.ListProjectCard = arr;

                   console.log("ListProjectCard",this.ListProjectCard);

                 if(this.iseditcard){
                    this.addProjectCard();
                    this.dialoglaoshiVisible=false;

                }else{
                  this.dialoglaoshiVisible=false;
                }
              
                 
      },
    addProjectCard(){
      var data = { SelectStoresID:this.SelectStoresID,        
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          ProjectID:this.ProjectID,
          ListProjectCard:this.ListProjectCard,
         
        }
        var that = this
        this.ajax('addProjectCard.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
             
              that.getListProjectCard()
             
            }

        })
    },
      changedian(){
      this.pageparm ={
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
   this.getType()
    this.getList()
    this.getCardType()
    this.getRowType()
    },
     getDianList(){
       var data = { 
         SelectStoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID")
      }
        var that = this
       this.ajax('getListStores.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
               that.DianList =res.data
               
            }

      })
},
    save(){
      var list = Array.from(this.ListPreAboutForms)
      var  cd = false
      list.forEach(items => {
        if(items.Title == ''){
            cd = true
        }
      });
      if(cd == true){
          this.$message({
              duration:2000,
              message:'请输入标题'
          });
      } else {
          this.preShow = false
          this.editForm.ListPreAboutForms =  Array.from(this.ListPreAboutForms)
      
          for(var i = 0 ;i<this.editForm.ListPreAboutForms.length;i ++){
              this.editForm.ListPreAboutForms[i].sort = i       
          }
      }
      
     
     
    },
     dragstart(value) {
            this.oldData = value
        },

        // 记录移动过程中信息
        dragenter(value, e) {
            this.newData = value
            e.preventDefault()
        },

        // 拖拽最终操作
        dragend(value, e) {
            if (this.oldData !== this.newData) {
                let oldIndex = this.ListPreAboutForms.indexOf(this.oldData)
                let newIndex = this.ListPreAboutForms.indexOf(this.newData)
                let newItems = [...this.ListPreAboutForms]
                // 删除老的节点
                newItems.splice(oldIndex, 1)
                // 在列表中目标位置增加新的节点
                newItems.splice(newIndex, 0, this.oldData)
                this.ListPreAboutForms = [...newItems]
            }
        },


        // 拖动事件（主要是为了拖动时鼠标光标不变为禁止）
        dragover(e) {
            e.preventDefault()
        },

    todel(items,index){
      if(items.isedit == 0){
           if(this.title == '添加'){
        this.ListPreAboutForms.splice(index, 1)
      } else {
        this.timer =  new Date().getTime()
        items.state = 3
      }
    } else {
      this.$message({
  
              duration:2000,
              message:'无法删除'
            });
    }
     
       
    },
    toadd(type){
      
        var list = {
          length:this.ListPreAboutForms.length,
          Title:'',
          fType:type,
          objID:this.editForm.ID,
          isbt:'1',
          state:1,
          objType:'1',
          isedit:0,
         
        }
     
      this.ListPreAboutForms.push(list)      
 
    },
    hover(items){
      items.show = true
      this.timer =  new Date().getTime()
      console.log(items.show)
      // console.log('1111')
    },
    UpRoll(items){
      items.show = false
      this.timer =  new Date().getTime()
 
        console.log(items.show)    
    },
    openPreAbout(){
      if(this.title == '修改'){
            for(var i= 0;i<this.editForm.ListPreAboutForms.length;i++ ){
                this.editForm.ListPreAboutForms[i].length = i
                this.editForm.ListPreAboutForms[i].state = 0
            }
      }
      this.ListPreAboutForms = this.editForm.ListPreAboutForms
      this.preShow = true
    },
    toTop(row){
      var data = { SelectStoresID:this.SelectStoresID,        
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          ProjectID:row.ID,
          SelectStoresID:this.SelectStoresID
        }
        var that = this
        this.ajax('editProjectDesc.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
           
              that.getList()
             
            }

        })
 
    },
    toDown(row){
      var data = { SelectStoresID:this.SelectStoresID,        
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          ProjectID:row.ID,
         
        }
        var that = this
        this.ajax('editProjectAes.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
             
              that.getList()
             
            }

        })
    },toshelves(){
      
      const loading = this.$loading({
          lock: true,
          text: '加载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      var data = { SelectStoresID:this.SelectStoresID,        
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
           
        }
        var that = this
          this.ajax('getListProjectshelves.aspx',JSON.stringify(data),"POST",function(res){
            if (res.orsuccess == "1") {
       
                that.ListProjectshelves = res.data
                that.shelvesSure = true
               loading.close();
          } 
       })
    },editshelves(row){
      this.$confirm("确定上架吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
        var data = { 
          SelectStoresID:this.SelectStoresID,        
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          ProjectID:row.ID,
          isshelves:1,

        }
        var that = this
        this.ajax('editProjectshelves.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "上架成功",duration:2000,
              });
              that.toshelves()
              that.getList()

             
            }

        })
        })
        .catch(() => {
            ;
        });
    },
      toSort(){
          this.sortSure = true
    },
    getCardType(){
        var data = { SelectStoresID:this.SelectStoresID,        
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
            pages:1,
            psize:100,
        }
        var that = this
          this.ajax('getListMemberCard.aspx',JSON.stringify(data),"POST",function(res){
            if (res.orsuccess == "1") {
       
                // that.typeList = res.data
                //  loading.close();
          } 
       })
    
    },
    toChooseColor(item){
      this.editForm.color = item
      this.colorShow =false
    },
    toColor(){
      console.log(this.colorShow)
      this.colorShow = true
    },
    toAll(){
      this.active = ''
      this.name = '全部'
      this. pageparm={
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
      this.getList()
    },
    toChoose(item){
        this.active = item.ID
        console.log(item.ID)
        this.name = item.ProjectTypeName
        this. pageparm={
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
        this.getList()
    },
    handlePassword(row){
          if (row != undefined && row != 'undefined') {
              this.title1 = '编辑类别'
              this.id= row.ID
              this.ProjectTypeName = row.ProjectTypeName
          } else {
              this.title1 = '添加类别'
               this.id= ''
              this.ProjectTypeName =  ''
          }
 


      this.passShow = true

    },

subProjectTypeName(){
    if(this.ProjectTypeName == ''){
             this.$message({
  
              duration:2000,
              message:'请输入类别'
            });
    }else {
        if(this.title1 == '添加类别'){
        var data = { 
                  SelectStoresID:this.SelectStoresID,        
                  token: localStorage.getItem("token"),
                  StoresID:localStorage.getItem("StoresID"),
                  ProjectTypeName:this.ProjectTypeName
              }
        var that = this
        this.ajax('addProjectType.aspx',JSON.stringify(data),"POST",function(res){
            if (res.orsuccess == "1") {
                that.$message({
              type: "success",
              duration:2000,
              message:'添加成功'
            });
            that.getType()
            that.getList()
            that.passShow = false
                  // that.tableLoading = false
                  // that.typeList = res.data
                  //  loading.close();
            } 
        })
    
      } else {
         var data = { SelectStoresID:this.SelectStoresID,        
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          ProjectTypeName:this.ProjectTypeName,
          ProjectTypeID:this.id
      }
      var that = this
      this.ajax('editProjectType.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
              that.$message({
            type: "success",
            duration:2000,
            message:'修改成功'
          });
           that.getType()
          that.getList()
          that.passShow = false
              
          } 
       })
    
      }
    }
},
delForm(){
this.$confirm("确定删除？会删除该项目关联的所有排班数据。", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
        var data = { 
          SelectStoresID:this.SelectStoresID,        
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          ProjectID:this.editForm.ID,

        }
        var that = this
        this.ajax('delProject.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "删除成功",duration:2000,
              });
              that.closeDialog()
              that.getType()
              that.getList()
              //  that.provinceList = res.data
            }

        })
        })
        .catch(() => {
            ;
        });
},
    handleChong(row){
      this.editForm.ManageLoginID = row.ID
      this.editForm.money = row.money
       this.chongShow = true
      this.money = ''
    },
        getType(){
      var data = { SelectStoresID:this.SelectStoresID,        
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
            pages:1,
            psize:100,
      }
      var that = this
      this.ajax('getListProjectType.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.tableLoading = false
                that.typeList = res.data
                //  loading.close();
          } 
       })
    
    },
    getList(){

    //  this.tableLoading = true
      var data = { 
        SelectStoresID:this.SelectStoresID,        
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          pages:this.formInline.page,
          psize:100,
          ProjectTypeID:this.active
          // StaffTypeID:this.active
      }
       const loading = this.$loading({
          lock: true,
          text: '加载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      
        var that = this
      this.ajax('getListProject.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.tableLoading = false
             that.tableData = res.data
          

                 loading.close();
          } 

      })
  
    },
    // 获取公司列表
    delimglb(imgtype){
      if(imgtype==1){
        this.img1="";
      }else if(imgtype==2){
        this.img2="";
      }else if(imgtype==3){
        this.img3="";
      }
    },
    uploadPicture(name) {
        this.timer = new Date().getTime()
      this.cropperName = name;
      this.cropperModel = true;
    },
    //图片上传成功后
    handleUploadSuccess(data) {
       this.cropperModel = false
      if(this.cropperName == 'KFQrCode'){
        this.editForm.KFQrCode = data.url

      }
      if(this.cropperName == 'HeadUrl'){
          this.editForm.HeadUrl = data.url
      }
      if(this.cropperName == 'img1'){
          this.img1 = data.url
      }
            if(this.cropperName == 'img2'){
          this.img2 = data.url
      }
            if(this.cropperName == 'img3'){
          this.img3 = data.url
      }

      this.cropperModel = false;
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getList()
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    getInfo(row){
      this.ProjectID = row.ID;
       var data = { 
          SelectStoresID:this.SelectStoresID,        
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          ProjectID:row.ID
        }
        var that = this
        this.ajax('getProjectInfo.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {

              that.editForm = res.data
                that.editInfo(row)
              //  that.provinceList = res.data
            }

        })
    },
    editInfo(row){
    
    if(this.iskczk==1){
      this.getListProjectCard();
    }
    this.timer = new Date().getTime()
       

      if(this.editForm.CardIDs != ''){
            this.editForm.CardIDs = this.editForm.CardIDs.split(",")
        } else {
        
        }

        this.editForm.isPreAboutInfo = Number(this.editForm.isPreAboutInfo) 
        this.editForm.ishot = Number(this.editForm.ishot) 
        this.editForm.isjp = Number(this.editForm.isjp) 
        this.editForm.isPay = Number(this.editForm.isPay) 
        this.editForm.isshelves = Number(this.editForm.isshelves)
        this.editForm.isWKYY = Number(this.editForm.isWKYY) 
        this.editForm.isStaff = Number(this.editForm.isStaff) 

        
        var  that = this

          if(row.listProjectImg.length>0 && row.listProjectImg[0].ImgUrl !='' ){
                that.img1 = row.listProjectImg[0].ImgUrl
              } else {
                 that.img1 =""
              }
                          if(row.listProjectImg.length>1 && row.listProjectImg[1].ImgUrl !=''){
   that.img2 = row.listProjectImg[1].ImgUrl
              }else {
                 that.img2 =""
              }
                            if(row.listProjectImg.length>2 && row.listProjectImg[2].ImgUrl !=''){
           that.img3 = row.listProjectImg[2].ImgUrl
              }else {
                 that.img3 =""
              }
              if(this.editForm.isPreAboutInfo == 1){
                this.getPreAboutInfo()
              } else {
              this.editForm.ListPreAboutForms = [{
                  length:1,
                  Title:'预约时间',
                  fType:2,
                  objID:this.editForm.ID,
                  isbt:'1',
                  state:1,
                  objType:'1',
                  isedit:1,
                }]
           }
    },
    //显示编辑界面
    handleEdit: function(row) {
      if(this.typeList.length >0){
              this.activeName = 'first'
        this.timer = new Date().getTime()
     
      if (row != undefined && row != 'undefined') {
        if(this.q2 == true){
          this.title = '修改'
          this.getInfo(row)
           this.editFormVisible = true
        }
        
      
            
      } else {
        
        this.title = '添加'
        this.img1 = ''
        this.img2 = ''
        this.img3 = ''
        this.ListProjectCard=[];

        this.editForm = {
              RowTypeID:'',
              color:'#9c4b4b',
              Timelength:60,
              isjp:0,
              ishot:0,
              isPreAboutInfo:0,
              ProjectName:'',
              isshelves:1,
              HeadUrl:'',
              Amount:0,
              ProjectTypeID:'',
              CardIDs:'',
              isPay:0,
              PayAmount:0,
              isWKYY:0,
              isStaff:1,
              xhAmount:'' ,
              xhnumber:'',
              TimelengthSJ:30,
              RenInfo:1,
              RowType:'',
              ListProjectCard:[],
              ListPreAboutForms:[{
                  length:1,
                  Title:'预约时间',
                  fType:2,
                  objID:0,
                  isbt:'1',
                  state:1,
                  objType:'1',
                  isedit:1,
                }]
          }
        if(this.iszjyy == 1){
          this.editForm.isPreAboutInfo = 1 
        } else {
           this.editForm.isPreAboutInfo = 0
        }
        if(this.RowTypeList.length == 1){
           this.editForm.RowType = this.RowTypeList[0].RowType
           this.editForm.RowTypeID = this.RowTypeList[0].ID
        }
        if(this.typeList.length == 1){
           this.editForm.ProjectTypeID = this.typeList[0].ID
        }
              this.editFormVisible = true
      }
      } else {
         this.$message({message: "请先添加类别"});
      }

    },
getPreAboutInfo(){
    var data = { 
          SelectStoresID:this.SelectStoresID,        
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          objType:1,
          objID:this.editForm.ID
        }
        var that = this
        this.ajax('getListPreAboutForms.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {

              that.editForm.ListPreAboutForms = res.data

              //  that.provinceList = res.data
            }

        })
  
},
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.editForm.lbimgs = ''
      if(this.img1 !='' && this.img1  )
        this.editForm.lbimgs = this.editForm.lbimgs + this.img1 + ','
      if(this.img2 !='' && this.img2 )
        this.editForm.lbimgs = this.editForm.lbimgs   +this.img2  + ','
      if(this.img3 !='' && this.img3)
        this.editForm.lbimgs = this.editForm.lbimgs  + this.img3 

      this.$refs[editData].validate(valid => {
        if (valid) {
          var that = this
          this.RowTypeList.forEach(items => {
          
            if(items.ID == this.editForm.RowTypeID){
              this.editForm.RowType = items.RowType
              console.log('1111',this.editForm.RowType)
            }
          });
          // var ls  = [...this.ListPreAboutForms] 
            // console.log(this.ListPreAboutForms)
            var data = this.editForm
            if(this.editForm.CardIDs){
                var card = [...this.editForm.CardIDs]
               data.CardIDs =  card.join(",")
         
            }
         
            data.token=localStorage.getItem("token")
            data.SelectStoresID = this.SelectStoresID
            data.StoresID=localStorage.getItem("StoresID")
             data.ListProjectCard= this.ListProjectCard

            console.log(data.ListPreAboutForms)
            // data.ListPreAboutForms = JSON.stringify(data.ListPreAboutForms)
     
            if(this.title == '添加'){
              this.ajax('addProject.aspx',JSON.stringify(data),"POST",function(res){
                              if (res.orsuccess == "1") {

                                  that.$message({
                                    type: "success",
                                    message: "新建成功",duration:2000,
                                  });
                                  that.editFormVisible = false
                                  that.getList()
                                }

                            })

               

            }else {
              data.ProjectID = this.editForm.ID
              
             this.ajax('editProject.aspx',JSON.stringify(data),"POST",function(res){
                     if (res.orsuccess == "1") {
                              that.$message({
                                    type: "success",
                                    message: "修改成功",duration:2000,
                                  });
                                  that.editFormVisible = false
                                  that.getList()
                                }                                 

                    })         

            }
        } else {
          return false
        }
      })
    
    },


    handlejie(row) {
      if(row.Isdisable == 0){
 this.$confirm('确定要禁用吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
            this.jie(row)
        })
        .catch(() => {
          
        })
      } else {
this.$confirm('确定要解禁吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
            this.jie1(row)
        })
        .catch(() => {
          
        })
      }
 
     
    },

        toDel(row){
      
       this.$confirm("确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
        var data = { SelectStoresID:this.SelectStoresID,        
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          ProjectTypeID:row.ID,
        
        }
        var that = this
        this.ajax('delProjectType.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "删除成功",duration:2000,
              });
              that.getType()
              that.getList()
              //  that.provinceList = res.data
            }

        })
        })
        .catch(() => {
            ;
        });
   
    },
    // toDel(){
    //     this.$confirm('确定要删除吗?', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   })
    //     .then(() => {
    //         this.delete(row)
    //     })
    //     .catch(() => {
    //       this.$message({
    //         type: 'info',
    //         message: '已取消删除'
    //       })
    //     })
    // },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
            this.delete(row)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.shelvesSure = false,
      this.sortSure = false,
      this.colorShow = false,
      this.passShow = false,
      this.chongShow = false,
      this.editFormVisible = false
      this.preShow = false
    }
  }
}
</script>

<style scoped>
.look{
  position: absolute;
  right: 0;
  bottom: 0;
  margin-bottom:5px;
  margin-right:5px;
  font-size: 12px;
  color:#65a8ff;
}
.mian{
  height: 300px;
  overflow: auto;
  overflow-x: hidden
}
.hen{
  width: 95%;
  border: 1px dashed #65a8ff;
  margin-left: 2.5%;
  padding-top:10px;
  padding-bottom: 10px;
}
.mainTitle{
  border-radius: 5px;
  width: 95%;
  height: 95%;
  background-color: white;
}
.left{
  background-color: #e0e0e0;
}
.jingp{
  width:50px;

  margin-left: 10px;
  font-size: 13px;
}
.kuai{
  margin-left: 10px;
  border-radius: 20px;
  width: 20px;
  height: 20px;
}
.bgColor{
  width:215px;
  height:30px;
  border:1px solid #808080;
  margin-top:5px;
  border-radius: 4px;
}
.main{
  position: absolute;
}
.content{
    font-size: 12px;
  color: #999;
  line-height: 20px;
}
.titleMain{
    font-size: 14px;
    color: #191919;
    line-height: 22px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.offline___NHq4e1 {
    position: absolute;
    top: -1px;
    left: -4px;
    padding: 0.5px 4px 0.5px 4px;

    background: rgba(255, 101, 247, 0.04);
    border-radius: 0 8px 0 8px;
    font-size: 12px;
    text-align: center;
    line-height: 20px;

}
.offline___NHq4e {
    position: absolute;
    top: -1px;
    right: -1px;
    padding: 0.5px 4px 0.5px 4px;
    /* width: 64px; */
    /* height: 22px; */
    background: rgba(255, 101, 247, 0.04);
    border-radius: 0 8px 0 8px;
    border: 1px solid rgba(187, 14, 255, 0.2);
    font-size: 12px;
    text-align: center;
    line-height: 20px;
    color: #b336fc;
}
.box{
  position: relative;
    width: calc((100% - 80px)/4);
    padding: 20px;
    box-sizing: border-box;
    display: inline-block;
    margin-right: 16px;
    margin-bottom: 16px;
    border-radius: 8px;
    border: 1px solid #ececec;
    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 8%);
    height: 130px;
}
@media screen and ( max-width: 1400px ) {
  .box{
    cursor: pointer;
    width: calc((100% - 60px)/3);
  }
}
.box:hover{
  box-shadow: 0 4px 16px 0 rgb(0 0 0 / 16%);
}
.shadow:hover {
    border:1px solid #409EFF;border-radius:2px
}
.shadow {
    border:1px solid #ffffff;border-radius:2px
}

.xiang{
    padding: 1px 4px  1px 4px;
    background-color: #f7f7f7;
    border:1px solid #bbbbbb;
    border-radius: 3px;
    font-size: 10px;
    color:#bbbbbb;
}
  
/* .el-switch__core::after{
 height: 12px !important;
 width :12px !important;
} */
   
.title{
    margin-top: 10px;
    height: 30px;
    font-size: 13px;
    font-weight: bolder;
    border-radius: 3px;
    border-left: 5px solid #334157;

}
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
 
.itemWrap___33SF3 {
    text-align: left;
    margin-bottom: 8px;
    padding: 0 12px;
    line-height: 40px;
    background: #e6f7ff;
    border-radius: 8px;
 }
 
.g-items-wrap {
    padding: 10px 15px;
    border: 1px dashed #40a9ff;
}
.f-mt-10 {
    margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/project/project.vue